// TIPO_FRETE do cadastro de empresas do CIGAM (coluna AU do Clientes.csv):
// "1-Emitente" = CIF (frete por conta da ZSB), "2-Destinatario" = FOB (por conta do cliente).
export type TipoFrete = 'CIF' | 'FOB';

export function tipoFrete(value: string | null | undefined): TipoFrete | null {
  const raw = String(value ?? '').trim().toUpperCase();
  if (!raw) return null;
  if (raw.startsWith('1') || raw.includes('EMITENTE') || raw === 'CIF') return 'CIF';
  if (raw.startsWith('2') || raw.includes('DESTINAT') || raw === 'FOB') return 'FOB';
  return null;
}

export function tipoFreteLabel(value: string | null | undefined, fallback = 'Não informado') {
  return tipoFrete(value) ?? fallback;
}

// Frete efetivo do cliente: o do CIGAM tem prioridade; sem ele, o informado
// manualmente por um vendedor (zsb_clientes.frete_manual).
export function freteDoCliente(cliente: { frete?: string; freteManual?: string } | null | undefined): TipoFrete | null {
  return tipoFrete(cliente?.frete) ?? tipoFrete(cliente?.freteManual);
}
